import React from 'react';
import MIcon from './MIcon';

/* ── Variantes base ─────────────────────────────────────────────────────── */
const VARIANTS = {
  info:        { bg: '#E8F0FE', color: '#1558D6', icon: 'info' },
  success:     { bg: '#E8F5E9', color: '#1E8E3E', icon: 'check_circle' },
  warning:     { bg: '#FFF3E0', color: '#E37400', icon: 'warning' },
  error:       { bg: '#FFEBEE', color: '#D93025', icon: 'cancel' },
  alternative: { bg: '#E8DEF8', color: '#6750A4', icon: 'help' },
  neutral:     { bg: '#F3F4F6', color: '#6B7280', icon: 'lock' },
};

/* ── Mapeo de estados ────────────────────────────────────────────────────── */
export const STATUS_VARIANT = {
  open:        'info',
  in_progress: 'alternative',
  escalated:   'warning',
  scheduled:   'neutral',
  resolved:    'success',
  forwarded:   'success',
};
export const STATUS_LABEL = {
  open:        'Abierto',
  in_progress: 'En progreso',
  escalated:   'Escalado',
  scheduled:   'Agendando',
  resolved:    'Resuelto',
  forwarded:   'Derivado',
};

/* ── Mapeo de prioridades ────────────────────────────────────────────────── */
export const PRIO_VARIANT = {
  low:      'success',
  medium:   'warning',
  high:     'info',
  critical: 'error',
};
export const PRIO_LABEL = {
  low:      'Baja',
  medium:   'Media',
  high:     'Alta',
  critical: 'Crítica',
};
const PRIO_ICON = {
  low:      'arrow_downward',
  medium:   'remove',
  high:     'arrow_upward',
  critical: 'error',
};

/**
 * Chip genérico del design system.
 * Props:
 *   variant  — 'info' | 'success' | 'warning' | 'error' | 'alternative' | 'neutral'
 *   label    — texto
 *   icon     — nombre de Material Symbol (opcional, sobreescribe el del variant)
 *   style    — estilos adicionales
 */
export function Chip({ variant = 'info', label, icon, style = {} }) {
  const v   = VARIANTS[variant] || VARIANTS.info;
  const ico = icon ?? v.icon;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      height: 20, padding: '0 8px',
      borderRadius: 20, border: 'none',
      background: v.bg, color: v.color,
      fontSize: 11, fontWeight: 600,
      whiteSpace: 'nowrap', flexShrink: 0,
      lineHeight: 1,
      ...style,
    }}>
      <MIcon name={ico} size={12} fill={0} weight={400} color={v.color} />
      {label}
    </span>
  );
}

/** Chip de estado de ticket */
export function StatusChip({ status, style }) {
  return (
    <Chip
      variant={STATUS_VARIANT[status] || 'neutral'}
      label={STATUS_LABEL[status] || status}
      style={style}
    />
  );
}

/** Chip de prioridad de ticket */
export function PrioChip({ priority, style }) {
  return (
    <Chip
      variant={PRIO_VARIANT[priority] || 'neutral'}
      label={PRIO_LABEL[priority] || priority}
      icon={PRIO_ICON[priority]}
      style={style}
    />
  );
}

/** Chip de nivel (N1–N5) */
const LEVEL_VARIANT = ['info', 'alternative', 'warning', 'error', 'neutral'];
export function LevelChip({ level, style }) {
  return (
    <Chip
      variant={LEVEL_VARIANT[(level ?? 1) - 1] || 'neutral'}
      label={`N${level}`}
      icon="layers"
      style={style}
    />
  );
}

export default Chip;
